import { render, staticRenderFns } from "./opsiya.vue?vue&type=template&id=2dccc1f0&scoped=true&"
import script from "./opsiya.vue?vue&type=script&lang=js&"
export * from "./opsiya.vue?vue&type=script&lang=js&"
import style0 from "./opsiya.vue?vue&type=style&index=0&id=2dccc1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dccc1f0",
  null
  
)

export default component.exports